import {BRAILLER_LOAN_STATUS_LIST, REPAIR_STATUS_LIST} from "../braillerConstants";

export const BRAILLER_LOAN_STATUS_DISPLAY_OPTIONS = BRAILLER_LOAN_STATUS_LIST;
export const BRAILLER_REPAIR_STATUS_DISPLAY_OPTIONS = REPAIR_STATUS_LIST;